<!-- ============================================================ -->
<!-- STEP 1: Widget CROEM — Tokenizacion de tarjeta              -->
<!-- ============================================================ -->
<div *ngIf="step === 1">
  <div class="card border-0 shadow-sm">
    <div class="card-header bg-primary text-white">
      <div class="d-flex align-items-center">
        <i class="fas fa-credit-card me-2"></i>
        <span class="fw-bold">Datos de la Tarjeta Internacional</span>
      </div>
    </div>
    <div class="card-body">
      <!-- Loading -->
      <div *ngIf="widgetLoading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2 text-muted">Cargando formulario de tarjeta...</p>
      </div>

      <!-- Error -->
      <div *ngIf="widgetError" class="alert alert-danger">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ widgetError }}
        <button class="btn btn-sm btn-outline-danger mt-2" (click)="loadWidget()">Reintentar</button>
      </div>

      <!-- Widget iframe -->
      <div *ngIf="!widgetLoading && !widgetError">
        <p class="text-muted small mb-3">
          Ingrese los datos de la tarjeta Visa o MasterCard internacional.
          Haga clic en "Guardar" para continuar.
        </p>
        <iframe
          *ngIf="widgetIframeUrl"
          id="croem-widget-iframe"
          [src]="widgetIframeUrl"
          style="width: 100%; height: 380px; border: none; overflow: hidden;"
          scrolling="no">
        </iframe>
      </div>
    </div>
    <div class="card-footer bg-white border-top-0">
      <button class="btn btn-outline-secondary" (click)="cancel()">
        <i class="fas fa-arrow-left me-1"></i> Volver
      </button>
    </div>
  </div>
</div>

<!-- ============================================================ -->
<!-- STEP 2: CVV + Confirmacion                                   -->
<!-- ============================================================ -->
<div *ngIf="step === 2">
  <div class="card border-0 shadow-sm">
    <div class="card-header bg-primary text-white">
      <div class="d-flex align-items-center">
        <i class="fas fa-lock me-2"></i>
        <span class="fw-bold">Confirmar Pago</span>
      </div>
    </div>
    <div class="card-body">

      <!-- Mini tarjeta visual -->
      <div style="background: linear-gradient(135deg, #1e3a5f 0%, #2d5f8a 50%, #1e3a5f 100%);
                  border-radius: 12px; padding: 20px 24px; color: white; max-width: 380px;
                  margin: 0 auto 24px; position: relative; overflow: hidden;
                  box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
        <!-- Patron decorativo -->
        <div style="position: absolute; top: -20px; right: -20px; width: 120px; height: 120px;
                    border-radius: 50%; background: rgba(255,255,255,0.05);"></div>
        <div style="position: absolute; bottom: -30px; left: -30px; width: 100px; height: 100px;
                    border-radius: 50%; background: rgba(255,255,255,0.03);"></div>
        <!-- Brand -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <span style="font-size: 11px; text-transform: uppercase; letter-spacing: 2px; opacity: 0.7;">Tarjeta Internacional</span>
          <span style="font-size: 18px; font-weight: 700; letter-spacing: 1px;">
            {{ cardBrand === 'visa' ? 'VISA' : cardBrand === 'mastercard' ? 'MC' : '' }}
          </span>
        </div>
        <!-- Numero enmascarado -->
        <div style="font-size: 20px; letter-spacing: 3px; font-family: 'Courier New', monospace;
                    margin-bottom: 16px; text-align: center;">
          {{ maskedCard || '**** **** **** ****' }}
        </div>
        <!-- Nombre -->
        <div style="display: flex; justify-content: space-between; align-items: flex-end;">
          <div>
            <div style="font-size: 9px; text-transform: uppercase; opacity: 0.6; margin-bottom: 2px;">Titular</div>
            <div style="font-size: 14px; font-weight: 500; letter-spacing: 0.5px;">
              {{ cardHolderName || 'TITULAR' }}
            </div>
          </div>
          <div style="text-align: right;">
            <i class="fas fa-wifi" style="font-size: 18px; opacity: 0.5; transform: rotate(90deg); display: inline-block;"></i>
          </div>
        </div>
      </div>

      <!-- CVV Input -->
      <div class="form-group mb-4">
        <label for="cvv-input" class="form-label fw-bold">
          <i class="fas fa-key text-muted me-1"></i>
          Codigo de Seguridad (CVV)
        </label>
        <div class="d-flex align-items-center gap-3">
          <input
            id="cvv-input"
            type="password"
            class="form-control text-center"
            [(ngModel)]="cvv"
            maxlength="4"
            placeholder="***"
            autocomplete="off"
            style="max-width: 120px; letter-spacing: 8px; font-size: 22px; height: 48px;
                   border: 2px solid #d1d5db; border-radius: 10px;"
          />
          <small class="text-muted">3 o 4 digitos del reverso</small>
        </div>
      </div>

      <hr style="border-color: #e5e7eb;"/>

      <!-- Monto USD -->
      <div class="form-group mb-3">
        <label for="amount-input" class="form-label fw-bold">
          <i class="fas fa-dollar-sign text-muted me-1"></i>
          Monto a Pagar
        </label>
        <div class="input-group" style="max-width: 250px;">
          <span class="input-group-text" style="border-radius: 10px 0 0 10px;">$</span>
          <input
            id="amount-input"
            type="number"
            class="form-control"
            [(ngModel)]="amountUsd"
            min="1.00"
            step="0.01"
            placeholder="0.00"
            style="font-size: 18px; height: 48px;"
          />
          <span class="input-group-text" style="border-radius: 0 10px 10px 0;">USD</span>
        </div>
        <small class="text-muted" *ngIf="maxAmountUsd > 0">
          Saldo pendiente: ${{ maxAmountUsd.toFixed(2) }} USD
        </small>
      </div>

      <!-- IGTF Toggle -->
      <div class="form-check form-switch mb-3" style="padding-left: 2.8em;">
        <input
          class="form-check-input"
          type="checkbox"
          id="igtf-toggle"
          [(ngModel)]="applyIgtf"
          style="width: 44px; height: 22px; cursor: pointer;"
        />
        <label class="form-check-label" for="igtf-toggle" style="cursor: pointer; margin-left: 4px;">
          Aplicar IGTF (3%)
        </label>
      </div>

      <!-- Resumen de monto -->
      <div *ngIf="amountUsd > 0" class="rounded p-3 mb-2"
           style="background: #f0fdf4; border: 1px solid #bbf7d0;">
        <div class="d-flex justify-content-between" *ngIf="applyIgtf">
          <span class="text-muted">Monto base:</span>
          <span>${{ amountUsd.toFixed(2) }}</span>
        </div>
        <div class="d-flex justify-content-between" *ngIf="applyIgtf">
          <span class="text-muted">IGTF (3%):</span>
          <span>${{ igtfAmount.toFixed(2) }}</span>
        </div>
        <div class="d-flex justify-content-between fw-bold" [class.mt-1]="applyIgtf"
             [class.border-top]="applyIgtf" [class.pt-1]="applyIgtf">
          <span>Total a cobrar:</span>
          <span class="text-success fs-5">${{ finalAmount.toFixed(2) }} USD</span>
        </div>
      </div>

    </div>
    <div class="card-footer bg-white d-flex justify-content-between" style="border-top: 1px solid #e5e7eb;">
      <button class="btn btn-outline-secondary" (click)="step = 1; loadWidget()"
              style="border-radius: 10px;">
        <i class="fas fa-arrow-left me-1"></i> Cambiar tarjeta
      </button>
      <button
        class="btn btn-success btn-lg"
        (click)="confirmPayment()"
        [disabled]="!cvv || cvv.length < 3 || !amountUsd || amountUsd < 1.00"
        style="border-radius: 10px; padding: 10px 28px;">
        <i class="fas fa-shield-alt me-1"></i> Pagar ${{ finalAmount.toFixed(2) }}
      </button>
    </div>
  </div>
</div>

<!-- ============================================================ -->
<!-- STEP 3: Procesando                                           -->
<!-- ============================================================ -->
<div *ngIf="step === 3">
  <div class="card border-0 shadow-sm">
    <div class="card-body text-center py-5">
      <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
      <h5 class="text-primary">{{ processingMessage }}</h5>
      <p class="text-muted">No cierre esta ventana.</p>

      <!-- Challenge iframe -->
      <div *ngIf="showChallenge" class="mt-4">
        <div class="border rounded p-2">
          <iframe
            [src]="challengeSafeUrl"
            style="width: 100%; height: 400px; border: none;"
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups">
          </iframe>
        </div>
        <small class="text-muted mt-2 d-block">
          Complete la verificacion de seguridad de su banco.
        </small>
        <!-- Manual verification button -->
        <div class="mt-3">
          <button
            class="btn btn-warning"
            (click)="manualCheckChallenge()"
            [disabled]="manualChecking">
            <i class="fas fa-sync-alt me-1" [class.fa-spin]="manualChecking"></i>
            {{ manualChecking ? 'Consultando...' : 'Ya complete la verificacion' }}
          </button>
          <small class="text-muted d-block mt-1">
            Presione este boton despues de completar la verificacion del banco.
          </small>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================================================ -->
<!-- STEP 4: Resultado                                            -->
<!-- ============================================================ -->
<div *ngIf="step === 4">
  <!-- Exito -->
  <div *ngIf="result?.success" class="card border-success shadow-sm">
    <div class="card-header bg-success text-white">
      <div class="d-flex align-items-center">
        <i class="fas fa-check-circle me-2 fs-4"></i>
        <span class="fw-bold fs-5">Pago Procesado Exitosamente</span>
      </div>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-6">
          <small class="text-muted">Monto</small>
          <p class="fw-bold fs-5 text-success">${{ amountUsd.toFixed(2) }} USD</p>
        </div>
        <div class="col-6">
          <small class="text-muted">Autorizacion</small>
          <p class="fw-bold">{{ result?.authorizationNumber || '-' }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted">ID Transaccion</small>
          <p class="fw-bold">{{ result?.transactionId || '-' }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted">Tracking</small>
          <p class="fw-bold">{{ result?.clientTracking || '-' }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer bg-white d-flex justify-content-between">
      <button class="btn btn-outline-secondary" (click)="cancel()">
        <i class="fas fa-arrow-left me-1"></i> Volver
      </button>
      <button class="btn btn-success" (click)="goToPayments.emit()">
        <i class="fas fa-list me-1"></i> Ver pagos realizados
      </button>
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="!result?.success" class="card border-danger shadow-sm">
    <div class="card-header bg-danger text-white">
      <div class="d-flex align-items-center">
        <i class="fas fa-times-circle me-2 fs-4"></i>
        <span class="fw-bold fs-5">Pago No Procesado</span>
      </div>
    </div>
    <div class="card-body">
      <p class="mb-0">{{ result?.error || 'Error desconocido' }}</p>
    </div>
    <div class="card-footer bg-white d-flex justify-content-between">
      <button class="btn btn-outline-secondary" (click)="cancel()">
        <i class="fas fa-arrow-left me-1"></i> Volver
      </button>
      <button class="btn btn-outline-danger" (click)="retry()">
        <i class="fas fa-redo me-1"></i> Reintentar
      </button>
    </div>
  </div>
</div>
